import { Component, OnInit, Inject } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { ValidationSummary } from '@sd-portal/shared/validation';

@Component({
  selector: 'sd-portal-app-form-error-summary-sheet',
  templateUrl: './app-form-error-summary-sheet.component.html',
  styleUrls: ['./app-form-error-summary-sheet.component.scss']
})
export class AppFormErrorSummarySheetComponent implements OnInit {
  errors: ValidationSummary[] = [];

  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) readonly data: ValidationSummary[],
    private readonly sheetRef: MatBottomSheetRef<AppFormErrorSummarySheetComponent>
  ) {
    this.errors = [...data];
  }

  ngOnInit() {}

  dismiss() {
    this.sheetRef.dismiss();
  }
}
